import React, { Component } from 'react';
import { Layout, Row, Col, Tabs, Button, Form, Input, Table } from 'antd';
// import BaseList from '../../components/common/BaseList';
import { getUsers } from '../../api/OraganizationApis';
import { addUser } from '../../api/userProfile';

import OraganizationUpdate from './OraganizationUpdate';

import Amplify, { Auth } from 'aws-amplify';
import AppConfig from '../../Config/AppConfig';
import './organization.css';
import { formatPhoneNumber } from '../commonFunctions';

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: `${AppConfig.APP_IDENTITY_POOL_ID}`,
    // REQUIRED - Amazon Cognito Region
    region: `${AppConfig.APP_COGNITO_REGION}`,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: `${AppConfig.APP_COGNITO_USER_POOL_ID}`,
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: `${AppConfig.APP_CLIENT_ID}`,
  },
});

const { TabPane } = Tabs;

class AddUser extends Component {
  state = {
    userDetails: {},
  };

  handleOnChange = event => {
    this.setState({
      userDetails: {
        ...this.state.userDetails,
        [event.target.id]: event.target.value,
      },
    });
  };

  addUser = async e => {
    e.preventDefault();
    this.setState({ loading: true });
    await Auth.signUp({
      username: this.state.userDetails.email,
      password: this.state.userDetails.password,
    })
      .then(data => {
        this.saveUser(data.userSub);
      })
      .catch(err => {
        if (err.code === 'InvalidPasswordException') {
          alert('Invalid Password: \n- Minimum password length:6\n- Require at least one uppercase letter\n- Require at least one lowercase letter\n- Require at least one number\n- Require at least one nonalphanumeric character');
          this.setState({ value: true, loading: false });
        } else {
          alert(err.message);
          this.setState({ value: true, loading: false });
        }
      });
  };

  saveUser = async userId => {
    const data = {
      entityData: {
        id: userId,
        firstName: this.state.userDetails.firstName,
        lastName: this.state.userDetails.lastName,
        phone: this.state.userDetails.phone,
        email: this.state.userDetails.email,
        userProfile: 'A',
        orgId: this.props.orgId,
        recordStatus: true,
      },
    };
    console.log(data);
    addUser(data)
      .then(result => {
        if (result.success) {
          this.props.closeForm();
          this.props.getUsers();
        } else {
          console.log(result.errors);
          this.setState({ loading: false });
        }
      });
  };
  render() {
    return (
      <div>
        <Form className='form-border' onSubmit={this.addUser}>
          <Row className='add-lead-button-margin' style={{ marginTop: '20px' }}>
            <Col span={16} />
            <Col span={2} offset={1} className='add-lead-cancel'>
              <Button onClick={() => { this.props.closeForm(); }}>Cancel</Button>
            </Col>
            <Col span={2} className='add-lead-save'>
              <Button type="primary" htmlType='submit' loading={this.state.loading}>Save</Button>
            </Col>
          </Row>
          <Row>
            <Row>
              <Col span={9} offset={1}>
                <div
                  style={{
                    margin: '20px 0px 20px 0px',
                    borderRadius: 5,
                  }}
                  className='add-lead border-form-item'
                >
                  <Form.Item
                    label='First Name'
                  >
                    <Input label='firstName' id='firstName' value={this.state.userDetails.firstName} required onChange={e => this.handleOnChange(e)} />
                  </Form.Item>
                </div>
              </Col>
              <Col span={9} offset={1}>
                <div
                  style={{
                    margin: '20px 0px 20px 0px',
                    borderRadius: 5,
                  }}
                  className='add-lead border-form-item'
                >
                  <Form.Item
                    label='Last Name'
                  >
                    <Input label='lastName' id='lastName' value={this.state.userDetails.lastName} required onChange={e => this.handleOnChange(e)} />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={9} offset={1}>
                <div
                  style={{
                    margin: '20px 0px 20px 0px',
                    borderRadius: 5,
                  }}
                  className='add-lead border-form-item'
                >
                  <Form.Item
                    label='Email'
                  >
                    <Input label='Email' id='email' autoComplete="off" value={this.state.userDetails.email} required onChange={e => this.handleOnChange(e)} />
                  </Form.Item>
                </div>
              </Col>
              <Col span={9} offset={1}>
                <div
                  style={{
                    margin: '20px 0px 20px 0px',
                    borderRadius: 5,
                  }}
                  className='add-lead border-form-item'
                >
                  <Form.Item
                    label='Password'
                  >
                    <Input type='password' label='password' autoComplete="new-password" id='password' value={this.state.userDetails.password} required onChange={e => this.handleOnChange(e)} />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={9} offset={1}>
                <div
                  style={{
                    margin: '20px 0px 20px 0px',
                    borderRadius: 5,
                  }}
                  className='add-lead border-form-item'
                >
                  <Form.Item
                    label='Contact Phone'
                  >
                    <Input label='Contact Phone' id='phone' value={this.state.userDetails.phone} required onChange={e => this.handleOnChange(e)} />
                  </Form.Item>
                </div>
              </Col>
            </Row>

          </Row>
        </Form>
      </div>
    );
  }
}

class UsersList extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        title: <div className='list-head'>Name</div>,
        dataIndex: 'userName',
        className: 'list-data',
        key: 'userName',
        align: 'left',
        render: (text, data) => (
          `${data.firstName} ${data.lastName} `
        ),
      }, {
        title: <div className='list-head'>Email</div>,
        dataIndex: 'email',
        className: 'list-data',
        key: 'email',
        align: 'left',
      },
      {
        title: <div className='list-head'>Phone Number</div>,
        dataIndex: 'phone',
        className: 'list-data',
        key: 'phone',
        align: 'left',
        render: (phone, data) => (
          <span>{formatPhoneNumber(phone)}</span>
        ),
      },
      {
        title: <div className='list-head'>Profile</div>,
        dataIndex: 'userProfile',
        className: 'list-data',
        key: 'userProfile',
        align: 'left',
        render: (text, data) => (
          `${data.userProfile}` === 'A' ? 'Admin' : 'Employee'
        ),
      },
    ];
  }

  render() {
    return (
      <div>
        <Row>
          <Col span={ 22 } offset={ 1 }>
            <Table
              columns={this.columns}
              dataSource={this.props.data}
            />
          </Col>
        </Row>
      </div>
    );
  }

}

class OraganizationDetails extends Component {
  state = {
    leadsData: [],
    filterData: [],
    action: 'view',
    orgId: '',
  };
  componentDidMount() {
    const orgId = this.props.match.params.id;
    this.setState({
      orgId,
    });
    this.getUsers();
  }
  getUsers() {
    const orgId = this.state.orgId === '' ? this.props.match.params.id : this.state.orgId;
    getUsers(orgId)
      .then(result => {
        if (result.success) {
          this.setState({
            leadsData: result.data,
            filterData: result.data,
          });
        } else {
          console.log(result.errors);
        }
      });
  }
  render() {
    return (
      <div style={{ marginTop: '100px' }}>
        <div className='leads-details-tabs'>
          <Layout>
            <Row >
              <Col span={18} offset={3}>
                <div className='card-container lead-name-details'>
                  <Tabs type='card' style={{margin:"0px"}}> 
                    <TabPane tab='Details' key='1' style={{backgroundColor:"#FFF", margin:"0px"}}>
                      <OraganizationUpdate orgId={this.props.match.params.id} />
                    </TabPane>
                    <TabPane tab='Users' key='2' style={{backgroundColor:"#FFF", margin:"0px"}}>
                      {this.state.action === 'view' ?
                        <><Row>
                          <Col span={21} />
                          <Col span={3} style={{marginTop:"20px"}}>
                            <Button type="primary" onClick={() => { this.setState({ action: 'new' }); }}>Add User</Button>
                          </Col>
                        </Row><Row>
                            <UsersList data={this.state.filterData} />

                          </Row>
                        </>
                        : <Row>
                          <AddUser closeForm={() => this.setState({ action: 'view', loading: false, userDetails: {} })} orgId={this.state.orgId} getUsers={() => this.getUsers()} />
                        </Row>
                      }
                    </TabPane>
                  </Tabs>
                </div>
              </Col>
            </Row>
          </Layout>
        </div>
      </div>

    );
  }
}

export default OraganizationDetails;
